export default __webpack_public_path__ + "static/media/news_3.b8738893.png";